// extracted by mini-css-extract-plugin
export var label = "_fe-2";
export var slideContainer = "_fe-0";
export var slider = "_fe-1";